import React, { useState, useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import {
  IconSearch,
  IconClock,
  IconCalendar,
  IconArrowLeft,
  IconArrowRight,
  IconUser,
  IconBook,
  IconShare,
  IconCheck,
  IconPlus,
  IconEdit,
  IconTrash,
  IconChevronUp,
  IconChevronDown,
  IconUpload,
  IconX,
  IconChevronLeft,
  IconChevronRight,
  IconDotsVertical,
  IconStar,
} from "@tabler/icons-react";
import Footer from "./home/footer";
import { gsap } from "gsap";
import { API_URL, formatFileUrl } from "../utils/api";

// ==================== STATIC ARTICLES ====================
const staticArticles = [
   {
    slug: 'aswahul-kutubi-bada-kitabillah',
    title: 'അസ്വഹുൽ കുതുബി ബഅ്ദ കിതാബില്ലാ ',
    arabicTitle: 'أصح الكتب بعد كتاب الله',
    category: 'Hadith Science',
    author: 'റഈസുൽ ഉലമ സുലൈമാൻ ഉസ്താദ്',
    authorRole: 'Ra\'isul Ulama',
    date: 'May 19, 2026',
    readTime: '10 min read',
    image: 'https://images.unsplash.com/photo-1506880018603-83d5b814b5a6?auto=format&fit=crop&q=80&w=800',
    excerpt: 'അല്ലാഹുവിന്റെ കിത്താബ് കഴിഞ്ഞാൽ ഏറ്റവും പ്രബലമായ ഹദീസിന്റെ ഗ്രന്ഥമായ സ്വഹീഹുൽ ബുഖാരിയെക്കുറിച്ചും അതിന്റെ രചനയിലും സംരക്ഷണത്തിലും ഉള്ള സൂക്ഷ്മതയെക്കുറിച്ചും സംസാരിക്കുന്നു.',
    content: [
      {
        type: 'paragraph',
        text: 'ശാഫിഈ ഇമാം(റ) പറഞ്ഞിട്ടുണ്ട്: "ما تحت أديم السماء كتاب أصح من موطأ الإمام مالك" (ആകാശത്തിനു കീഴെ ഇമാം മാലികിന്റെ മുവത്വ എന്ന ഗ്രന്ഥത്തെക്കാൾ മികച്ച ഒന്നില്ല എന്ന്). നാസിറുസ്സുന്ന എന്നാണ് ഇമാം ശാഫിഈ (റ) അറിയപ്പെടുന്നത്. ഹദീസിൽ അഗാധമായ അറിവുള്ള ആളാണ് ഇമാം ശാഫിഈ (റ). അവരുടെ അഭിപ്രായത്തിൽ അത്ര കാമിലായ ഒരു കിതാബ് ഇല്ല എന്നർത്ഥം. ശാഫിഈ ഇമാം അങ്ങനെ പറയാൻ കാരണം അന്ന് ബുഖാരി ഉണ്ടാക്കിയിട്ടില്ല. ഉണ്ടായിരുന്നെങ്കിൽ ബുഖാരിയെ കുറിച്ച് ആയിരിക്കും ശാഫി ഇമാം പറയുക.'
      },
      {
        type: 'heading',
        text: 'ഇമാം ബുഖാരിയുടെ സൂക്ഷ്മതയും ചരിത്രവും'
      },
      {
        type: 'paragraph',
        text: 'ബുഖാരി ഇമാം ഓരോ ഹദീസും എവിടെയൊക്കെ ഉണ്ട് അവിടെയൊക്കെ പോയി പഠിച്ച ആളാണ്. അവരുടെ അസ്മാഉരിജാലിലെ ഗ്രന്ഥം (താരീഖുൽ കബീർ) മദീനയിൽ നിലാവെളിച്ചത്ത് ഇരുന്നുകൊണ്ടാണ് എഴുതിത്തീർത്തത്. ഇമാമിന്റെ ഉമ്മയും ബാപ്പയും മൂപ്പർ നന്നാവാനുള്ള കാരണങ്ങളാണ്. ഒരു സാധാരണ പണ്ഡിതൻ അല്ല ഇമാം. അവരുടെ ഉമ്മ ദുആക്ക് ഉത്തരം കിട്ടുന്ന ആളായിരുന്നു.'
      },
      {
        type: 'paragraph',
        text: 'ചെറുപ്പത്തിൽ ഇമാമിന്റെ കാഴ്ച നഷ്ടപ്പെട്ടിരുന്നു. ഉമ്മ നേരം വെളുക്കുവോളം ദുആ ചെയ്തു. അങ്ങനെ ഇബ്രാഹീം നബി(റ) നെ സ്വപ്നത്തിൽ കാണുകയും അവർ ഇങ്ങനെ പറയുകയും ചെയ്തു: "നിങ്ങളുടെ വല്ലാതെയുള്ള പ്രാർത്ഥന കാരണം നിങ്ങളുടെ മകന് കാഴ്ച തിരിച്ചു കിട്ടിയിരിക്കുന്നു." ഉമ്മ കുട്ടിയെ പരിശോധിച്ചു നോക്കുമ്പോൾ കാഴ്ചശക്തി കൈവരിച്ചിരുന്നു. ഇമാമിന്റെ ഉപ്പയും വലിയ ആളാണ്. ഇമാമിന്റെ പിതൃ പരമ്പരയിൽ പെടുന്ന ബർദിസ്ബ എന്ന വ്യക്തി മജൂസി ആയിരുന്നു. മജൂസി ആണെങ്കിലും അദ്ദേഹം അടിമ ഒന്നും ആയിരുന്നില്ല. വലിയ ധനാഢ്യൻ ആയിരുന്നു. അദ്ദേഹത്തിന്റെ സമ്പത്തിനെക്കുറിച്ച് മകനായ മുഗീറത് പറഞ്ഞത്: "ഞങ്ങളുടെ സമ്പത്തിൽ അൽപം പോലും ശുബ്ഹയുടെ മുതൽ ഇല്ല, എല്ലാം ഹലാലായ മുതലാണ്" എന്നാണ്. ഈ മുഗീറത്താണ് ആദ്യമായി മുസ്ലിമായത്. ബർദിസ്ബ മുസ്ലിം ആയിട്ടില്ല. അന്ന് ബുഖാറയിൽ അമീറായിരുന്ന യമാനുൽ ജുഅഫി എന്നിവർ മുഖേനയാണ് ഇദ്ദേഹം മുസ്ലിം ആകുന്നത്. ഒരാൾ മുഖേന മുസ്ലിമായാൽ അയാളുടെ വീട്ടു പേര് മുസ്ലിമായ ആൾക്കും പറയുന്ന പതിവ് ഇന്നും ഉണ്ട്. അങ്ങനെയാണ് ഇമാം ബുഖാരി ജുഅഫി ആയത്.'
      },
      {
        type: 'paragraph',
        text: 'ദുആക്ക് ഉത്തരം കിട്ടുന്ന ഉമ്മയും ഹലാലുകൊണ്ട് മക്കളെ പോറ്റിയ ഉപ്പയും, ഇത് ഇമാമിന് വലിയൊരു പോരിശയാണ്. ഇമാം ഹദീസിന്റെ കാര്യത്തിൽ വലിയ പരിശ്രമം നടത്തിയിരുന്നു. സമകാലീനർ ആണെങ്കിലും ഒരു തവണയെങ്കിലും അവരിൽ നിന്ന് സമാഅ് (ഹദീസ് കേൾക്കുക) ഉണ്ടാവണമെന്ന നിബന്ധന അവർക്കുണ്ടായിരുന്നു. ഇത് സ്ഥിരപ്പെട്ടിട്ടില്ലെങ്കിൽ ഇമാം ഹദീസ് മുത്തസിലാക്കാറില്ലായിരുന്നു. ബുഖാറയിൽ ഉള്ള ആളുകളുടെ ഹദീസുകൾ പഠിച്ചതിനു ശേഷം പിന്നെ അവിടെ നിന്ന് ശാം, മിസ്ർ തുടങ്ങി നിരവധി നാടുകളിലേക്ക് അവർ യാത്ര ചെയ്തു. അവിടെ നിന്നെല്ലാമുള്ള മഹത്തുക്കളുടെ അരികിൽനിന്ന് ഹദീസുകൾ പഠിച്ചു. ഏതെങ്കിലും ഒരാൾക്ക് വല്ല ശുബ്ഹയും ഉണ്ടെങ്കിൽ അയാളിൽനിന്ന് ഇമാം ഹദീസ് സ്വീകരിക്കില്ല.'
      },
      {
        type: 'paragraph',
        text: 'ഒരിക്കൽ ഒരു ഉസ്താദിന്റെ അരികെ ഹദീസ് പഠിക്കാൻ വേണ്ടി ചെന്നപ്പോൾ ഇമാമിനെ സൽക്കരിക്കാൻ വേണ്ടി ആടിനെ ഉസ്താദ് കൈ കാണിച്ചു കൊണ്ട് വിളിച്ചു, കയ്യിൽ ഒന്നുമില്ലായിരുന്നു. വല്ലതും തിന്നാൻ കിട്ടും എന്ന അർത്ഥത്തിൽ അടുത്തേക്ക് വന്ന ആടിനെ അദ്ദേഹം അറുത്തു. ഇത് കണ്ട് അദ്ദേഹം ഉസ്താദിൽ നിന്ന് ഹദീസ് സ്വീകരിച്ചില്ല. കാരണം അയാൾ മുത്തഹമായി (വഞ്ചനയുണ്ട്, ഹദീസിൽ ഇല്ലെങ്കിലും ഫീ നഫ്സിൽ). ഇങ്ങനത്തെ സൂക്ഷ്മതയുള്ള ആളാണ് ഇമാം.'
      },
      {
        type: 'heading',
        text: 'ഈമാനും കറാമത്തും ബുഖാരിയിൽ'
      },
      {
        type: 'paragraph',
        text: 'ബുഖാരി ഇമാം (റ) കിതാബുൽ ഈമാനിൽ കാര്യമായി വിമർശിക്കുന്നത് മുർജിഅതിനെയാണ്. ഇബാദത്ത് വേണ്ട, ഈമാൻ മാത്രം മതി എന്നു പറഞ്ഞിരിക്കുന്ന കള്ള ശൈഖുമാർ ആണ് ഇവർ. അവരെ എതിർത്തുകൊണ്ട് ഇമാം ബുഖാരി (റ) പറഞ്ഞു: "الإيمان قول وفعل" (ഈമാൻ എന്നാൽ വാക്കും പ്രവർത്തിയുമാണ്). പ്രവർത്തനങ്ങൾക്കനുസരിച്ച് അത് കൂടുകയും കുറയുകയും ചെയ്യും. കറാമത്ത് മുഅ്ജിസത്ത് പോലത്തെ വിഷയങ്ങൾ വരുന്നിടത്തെല്ലാം ഹദീസുകൾ ഇമാം ആവർത്തിച്ചു കൊണ്ടുവരും. ആ വിഷയം സുബൂത്താക്കാൻ വേണ്ടിയാണത്.'
      },
      {
        type: 'paragraph',
        text: 'ഹദീസ് തഹ്രിർ ചെയ്യുന്ന വിഷയത്തിൽ മുസ്ലിം ഇമാമിനേക്കാൾ തഹ്ഖീഖ് ബുഖാരി ഇമാമിനുണ്ട്. അതുകൊണ്ട് സമകാലീനർ ആണെങ്കിലും നേരിട്ട് കണ്ടിട്ടില്ലെങ്കിൽ അവരിൽനിന്ന് ഇമാം ബുഖാരി (റ) ഹദീസ് സ്വീകരിക്കുകയില്ല. വിമർശനങ്ങൾക്ക് വിധേയനായ റാവിയുടെ ഹദീസ് ഒരു സ്ഥലത്ത് പരാമർശിച്ചിട്ടുണ്ടെങ്കിൽ മറ്റൊരു സ്ഥലത്ത് അത് ഒഴിവാക്കിയിട്ടുണ്ടാകും. ഇങ്ങനെ സ്വീകാര്യതയുടെ വിഷയത്തിൽ ഏറ്റവും മുന്തിയതാണെന്ന് നമുക്ക് മനസ്സിലാക്കാൻ സാധിക്കുന്ന തരത്തിലുള്ള കാര്യങ്ങൾ ബുഖാരിയിൽ കാണാൻ കഴിയും. ബുഖാരിയാണ് ഏറ്റവും അസ്വഹ്. മുസ്ലിമാണ് അസ്വഹ് എന്ന് എവിടെയും വ്യക്തമായി പറഞ്ഞിട്ടില്ല.'
      },
      {
        type: 'paragraph',
        text: 'ചില മഗ്‌രിബി പണ്ഡിതന്മാർ മുസ്ലിം മികച്ച ഗ്രന്ഥമാണ് അതിനു മുകളിൽ മറ്റൊരു ഗ്രന്ഥമില്ല എന്ന് പറയുന്നുണ്ടെങ്കിലും അതിൽ നിന്നും പരമാവധി നമുക്ക് മനസ്സിലാക്കാൻ കഴിയുന്നത് രണ്ടും സമമാണ് എന്നാണ്. ഒരിക്കലും മുസ്ലിം ബുഖാരിയെ മറികടന്നിട്ടുണ്ട് എന്ന് മനസ്സിലാക്കാൻ കഴിയില്ല. ബുഖാരിയുടെ മേലെ ഹദീസിന്റെ ഗ്രന്ഥം ഒന്നുമില്ല. അല്ലാഹുവിന്റെ കിത്താബ് കഴിഞ്ഞാൽ ഏറ്റവും പ്രബലം അത് തന്നെയാണ്. അതിലെ ഹദീസുകളിൽ നിന്ന് വല്ലതും സ്വഹീഹിന്റെ മർത്തബയിൽ നിന്ന് ഹസന്റെ മർത്തബയിലേക്ക് എത്തിയിട്ടുണ്ടെങ്കിൽ കസ്റത്തു ത്വുറുഖ് കൊണ്ട് ഇമാം സ്വഹീഹിന്റെ സ്ഥാനത്ത് ആക്കും. അതുകൊണ്ടാണ് ബുഖാരിയിൽ ആവർത്തനം വല്ലാതെ കാണുന്നത്. അതിന് ഫാഇദ ഉണ്ടാകും.'
      },
      {
        type: 'heading',
        text: 'യൂനാനിയുടെ നുസ്ഖ'
      },
      {
        type: 'paragraph',
        text: 'യൂനാനിയുടെ നുസ്ഖയാണ് ഏറ്റവും പ്രബലം; ബുഖാരി ഇമാമിൽ നിന്ന് ഏറ്റവും കൂടുതൽ റിപ്പോർട്ട് ചെയ്തവർ നാലു പേരാണ്. ഒന്നാമത്തെ ആൾ ഇമാം ഫിറബിരി ആണ്. ഇദ്ദേഹത്തിൽ നിന്ന് 9 റാവിമാരാണ് പ്രധാനമായും റിപ്പോർട്ട് ചെയ്തത്. അവരിൽ നിന്ന് നിരവധി പേരും റിപ്പോർട്ട് ചെയ്ത വ്യത്യാസങ്ങളാണ് നുസ്ഖകളിൽ വ്യത്യാസമായി മാറുക. ബുഖാരി ഇമാം പലസ്ഥലത്തും ക്ലാസെടുത്തിട്ടുണ്ട്. ചിലപ്പോൾ വാക്കുകളിൽ മാറ്റങ്ങൾ വരാം. അതാണ് വ്യത്യാസങ്ങൾ അല്ലാതെ ശിഷ്യന്മാർക്കുണ്ടായ വഹ്മുകളല്ല.'
      },
      {
        type: 'paragraph',
        text: 'ചില വാക്കുകൾ നോക്കുമ്പോൾ വലിയ വ്യത്യാസമുള്ളതായി ഇൽമുൽ അറബിയ്യത്തിന് തോന്നും. അങ്ങനെ ഒരിക്കൽ ഇബ്നു മാലിക്കും മിസറിലെ പ്രഗൽഭ പണ്ഡിതനും സൂഫിയുമായ ശറഫുദ്ദീനുൽ യുനീനിയും കൂടി ഈ വ്യത്യാസത്തെക്കുറിച്ച് ചർച്ച ചെയ്തു. ഇബ്നു മാലിക് വലിയ ആളാണ്, ഇമാം നവവി(റ) അദ്ദേഹത്തെക്കുറിച്ച് വല്ലാതെ പുകഴ്ത്തി പറഞ്ഞിട്ടുണ്ട്.'
      },
      {
        type: 'quote',
        text: 'ഇബ്നുമാലിക് യൂനീനിയോട് ചോദിച്ചു: "ഹദീസുകൾ നിങ്ങൾക്ക് അതിന്റെ യഥാർത്ഥ സനദുകളിലേക്ക് സുബൂത്ത് ആക്കാൻ കഴിയുമോ?" കഴിയുമെന്നായിരുന്നു മറുപടി. "എന്നാൽ സംശയമുള്ളിടത്ത് ഞാൻ തൗജീഹും പറയാം" എന്ന് ഇബ്നു മാലിക് പറഞ്ഞു. അങ്ങനെ അവർ ഇരുവരും 40 പേരുള്ള ഒരു സദസ്സ് സംഘടിപ്പിച്ചു. ആ സദസ്സിൽ വച്ച് തീരുമാനിച്ച, എല്ലാവരും ഐക്യകണ്ഠമായി അംഗീകരിച്ച പതിപ്പാണ് യൂനീനിയുടെ നുസ്ഖ എന്നറിയപ്പെടുന്നത്. ആ സദസ്സിൽ ഉണ്ടായിരുന്നവരുടെ കോപ്പിയെക്കുറിച്ച് അസ്ൽ യൂനീനി എന്ന് പറയും. അതാണ് കാര്യമായി ഖസ്ത്വല്ലാനി ഒക്കെ ആസ്പദമാക്കിയത്.'
      },
      {
        type: 'heading',
        text: 'എന്റെ ബുഖാരിയിലെ ഉസ്താദുമാർ'
      },
      {
        type: 'paragraph',
        text: 'ബുഖാരി എനിക്ക് പകുതിയോളം ഓതി തന്നത് കൈപ്പറ്റ ഉസ്താദാണ്. പൂർത്തിയാക്കിയത് ദയൂബന്ദ് പഠന കാലത്താണ്. അവിടുത്തെ ശൈഖുൽ ഹദീസിന് ഒരു പ്രത്യേകതയുണ്ട്. ഒരു കൊല്ലം കൊണ്ട് ബുഖാരി തീർക്കും. അരക്കൊല്ല പരീക്ഷ വരെ ഒരു ക്ലാസ് ഉണ്ടാകും. അതുകഴിഞ്ഞ് രണ്ടോ മൂന്നോ ക്ലാസ്സുകൾ. കൊല്ല പരീക്ഷ കഴിഞ്ഞ് 13 ദിവസം കൂടി അവിടെ നിൽക്കണം. ആ സമയത്ത് കിതാബ് പൂർണമായി ഓതി തീർക്കും. എന്നിട്ട് ഒരു ഖത്മുൽ ബുഖാരി ഉണ്ടാകും. സംഭവബഹുലമായ ഒരു മജ്‌ലിസ് ആയിരിക്കും അത്. നിരവധി ആളുകൾ ഉണ്ടാകും. ആളുകൾ കുപ്പിയിലും പാത്രങ്ങളിലും ബർക്കത്ത് ഉദ്ദേശിച്ചുകൊണ്ട് വെള്ളവുമായി ആ മജ്‌ലിസിലേക്ക് വരും.'
      },
      {
        type: 'paragraph',
        text: 'ബറക്കത്തിന്റെ വിഷയത്തിൽ ദയൂബന്ദികൾക്ക് വലിയ കാര്യമാണ്. അവരെല്ലാം പുത്തൻവാദികളാണെന്ന നിലയിൽ പറയാനാവില്ല. മറിച്ച് ബറേൽവികൾ എന്ന വിഭാഗത്തിന്റെ എതിരെ നിൽക്കുന്നു എന്ന അടിസ്ഥാനത്തിലാണ് നമ്മൾ അവരെ അറിയുന്നത്. ഈ എതിർപ്പിന്റെ കാരണങ്ങളിൽ പെട്ടതാണ് പരിസരങ്ങളിലുള്ള മഖാമുകളിൽ ബറേൽവി വിഭാഗത്തിന്റെ സിയാറത്തുകളിൽ സ്ത്രീപുരുഷരുടെ കൂടിക്കലരൽ ഉണ്ടായപ്പോൾ ദയൂബന്ധികൾ അതിനെ എതിർത്തു. അപ്പോൾ അവർ സിയാറത്ത് ചെയ്യാൻ പറ്റുമെന്ന് തെളിയിക്കുന്ന ഉദ്ധരണികളുമായി വന്നു. അങ്ങനെ ഇരു കൂട്ടരും തമ്മിലുള്ള ഈ സംസാരം അൽപം അതിരുകടക്കുകയാണ് ചെയ്തത്. നമ്മൾ അംഗീകരിച്ചുവരുന്നത് ബറേൽവികളെയാണ്. ശരിക്കും നമുക്ക് രണ്ടിനെയും ആവശ്യമില്ല, ഇവിടെ സമസ്തയുണ്ടല്ലോ. ഉസൂലൊക്കെ നോക്കുമ്പോൾ കുറെയുള്ളത് ബറേൽവികൾക്കാണ്. വിലായത്ത് ഒക്കെ അവർ സുബൂത്താക്കുന്നുണ്ട്. ദയൂബന്ധികൾക്ക് അവരുടെ ഉസ്താദുമാരുടെ വാക്കിൽ പല വ്യത്യാസങ്ങൾ ഉണ്ടായിട്ടുണ്ട്. നമ്മൾക്ക് നമ്മുടെ ഉസ്താദുമാർ പറഞ്ഞു തന്ന കാര്യങ്ങളിൽ നിന്ന് ഇതുവരേക്കും ഒരു എതിരഭിപ്രായവും ഉണ്ടായിട്ടില്ല.'
      },
      {
        type: 'paragraph',
        text: 'അല്ലാമാ ഇബ്രാഹിം വല്യാബി ആണ് പ്രിൻസിപ്പാൾ. അദ്ദേഹം ഒക്കെ ശക്തമായ ഹഖിന്റെ ആളാണ്. തബ്ലീഗുകാർ വരുമ്പോൾ അദ്ദേഹം ചീത്ത പറയും. ജാഹിലീങ്ങൾ ഉലമാക്കളെ തബ്ലീഗ് ചെയ്യാനാണോ വന്നിട്ടുള്ളത് എന്ന് ചോദിക്കും. എനിക്ക് തിർമിദി ഓതിത്തന്ന ശൈഖ് ആണ് ഇദ്ദേഹം. ദയൂബന്ധിലെ ശൈഖുൽ ഹദീസ് സയ്യിദ് ശിഹാബുദ്ദീൻ എന്നവരാണ്. എല്ലാ ഫന്നുകളും നല്ലവണ്ണം തിരിയുന്ന ആളായിരുന്നു പ്രിൻസിപ്പൽ അല്ലാമ. സബ്ക്കുകൾക്കിടയിൽ ശർഹുതഹ്ദീബ് വായിക്കാൻ മഅ്ഖൂലാത്തും മൻഖൂലാത്തും പറയും. അവർ മുഹദ്ദിസുമാണ്, സ്വഹീഹ് മുസ്ലിം ആയിരുന്നു ക്ലാസുകൾ എടുത്തിരുന്നതും. ദയൂബന്ദിൽ എത്തിയകാലം മുതൽ തന്നെ അദ്ദേഹം മുസ്ലിമാണ് ക്ലാസുകൾ എടുത്തിരുന്നത്. ഞങ്ങൾ അവിടെ എത്തിയ സമയത്ത് 105 വയസ്സുണ്ട് അദ്ദേഹത്തിന്. അസർ നിസ്കാരങ്ങൾക്ക് ശേഷം അദ്ദേഹത്തിന്റെ വീട്ടുമുറ്റത്ത് ഉസ്താദുമാർ കൂടി സ്റ്റാഫ് യോഗമൊക്കെ കൂടും. എല്ലാ ഉസ്താദുമാരും മൂപ്പരുടെ ശിഷ്യന്മാരാണ്.'
      },
      {
        type: 'paragraph',
        text: 'ഒരിക്കൽ കോളേജിൽ വിദ്യാർത്ഥികളിൽ നിന്ന് ചെറിയൊരു പ്രശ്നം ഉണ്ടായപ്പോൾ പ്രിൻസിപ്പൽ അല്ലാമ ക്ലാസുകൾക്ക് വന്നില്ല. "ഞാൻ ഇനി അവർക്ക് ക്ലാസ്സെടുക്കില്ല" എന്ന് പറഞ്ഞു. ശേഷം ഇങ്ങനെ പറഞ്ഞു: "മൂന്ന് ഹറമാണ് ഉള്ളത്. ഒന്ന് അല്ലാഹുവിന്റെ ഹറം, അത് മക്കയിൽ ഉള്ളത്. മറ്റൊന്ന് നബി തങ്ങളുടെ ഹറം, അത് മദീനയിലേത്. മറ്റൊന്ന് ഔലിയാക്കളുടേത്, അതിൽ പെട്ട ഒന്നാണ് ഇത്. അതിന്റെ പരിശുദ്ധതക്ക് കളങ്കം ഏൽപ്പിച്ചവർക്ക് ഞാൻ ഇനി ക്ലാസുകൾ എടുക്കില്ല." അങ്ങനെ ഉസ്താദ് തിർമിദി ക്ലാസ് നിർത്തി.'
      },
      {
        type: 'paragraph',
        text: 'എന്നിട്ട് ഉസ്താദുമാരുടെ മഹത്വം അദ്ദേഹം പറഞ്ഞു: ഒരു ഉസ്താദിനെ തേടി കുറച്ചാളുകൾ വല്യാബിയുടെ ശൈഖിന്റെ അരികെ വന്നപ്പോൾ അദ്ദേഹം വല്യാബിയെ ഉസ്താദ് ആയി നിയോഗിച്ചു. ആദ്യമായി ആ സ്ഥലത്തേക്ക് വന്ന യാത്ര ക്ഷീണത്തിൽ വല്യാബി വേഗം കിടന്നുറങ്ങിപ്പോയി. നാളെ ക്ലാസ് എടുക്കാനുള്ളത് ഹമാസയിലെ 15 ബൈത്തുകളാണ്. മൂന്ന് ബൈത്ത് നോക്കി ഉറക്കം വന്നു ഉറങ്ങി. ശൈഖ് വന്ന് അടിച്ചു എണീപ്പിച്ചു: "എണീക്ക്, ഉറങ്ങുകയാണോ! നീ നാളെ ക്ലാസ് എടുക്കേണ്ടതല്ലേ..." എന്ന് വന്ന് പറഞ്ഞു (സ്വപ്നത്തിൽ). എഴുന്നേറ്റ് അരമണിക്കൂർ കൊണ്ട് മുഴുവൻ നോക്കി തീർത്തു. ഇതാണ് ഉസ്താദുമാരുടെ മഹത്വം. അവരുടെ ഗുരുത്തക്കേട് വാങ്ങയാൽ രക്ഷപ്പെടില്ല. "പ്രത്യേകമായ സനദ് ആർക്കും തരില്ല" എന്ന് അദ്ദേഹം പറഞ്ഞു. ഞങ്ങൾ പറഞ്ഞു: "ഞങ്ങൾ അതിനു വേണ്ടി വന്നതാണ്, ആ ബർക്കത്ത് ഉദ്ദേശിച്ചാണ് ഞങ്ങൾ വന്നിട്ടുള്ളത് എന്ന്. ഞങ്ങളാ പ്രശ്നത്തിൽ ഉണ്ടായിരുന്നില്ല" എന്നും പറഞ്ഞു. ഞങ്ങൾക്ക് ആ സനദ് കിട്ടി. പ്രധാനപ്പെട്ട സനദ് ഇങ്ങോട്ട് അയച്ചു തരലാണ് പതിവ്. നോമ്പിന് നാട്ടിലെത്തിയതിനു ശേഷം ആദ്യം അവിടുന്ന് മാർക്ക് ലിസ്റ്റ് അയച്ചുതന്നു. എന്നിട്ട് സനദ് ലഭിക്കാൻ വേണ്ടി 10 രൂപ അയക്കാനും പറഞ്ഞു. കുറച്ചു കിതാബുകൾ സമ്മാനമായി അയക്കുകയും ചെയ്തു. ഇവൻ തദ്‌രീസിനും ഫത്‌വ കൊടുക്കാനുമൊക്കെ അർഹനാണ് എന്നൊക്കെ എഴുതിയ ഒരു സനദും അവരുടെ ഉസ്താദുമാരുടെ സിൽസില എഴുതിയ ഒരു സനദും കിട്ടി. കടുപ്പമേറിയ പരീക്ഷയാണ് കോളേജിന്റേത്. പലരും വിജയിക്കില്ല. നാട്ടിലെത്തി 10 ദിവസത്തിന് ശേഷം മാർക്ക് ലിസ്റ്റ് വരുമ്പോഴാണ് വിജയിച്ചു എന്ന് അറിയുക. ചില മലേഷ്യക്കാർ പരീക്ഷ കഴിഞ്ഞ ഉടനെത്തന്നെ കോട്ടും തലപ്പാവും ഒക്കെ വാങ്ങി ശൈഖുമാരുടെ അടുത്ത് ചെന്ന് അതണിയും. ചിലർ കോട്ട് വാങ്ങി നാട്ടിലേക്ക് പോരും. ഒരുപക്ഷേ അവരൊന്നും ജയിച്ചിട്ടുണ്ടാവില്ല. 10 കിതാബുകൾ ഉണ്ടാവും പരീക്ഷയ്ക്ക്. പഠിക്കാനുള്ള ഭാഗം നിർണയിക്കുക ഒന്നുമില്ല. ദയൂബന്ദിലെ വലിയ ഹാൾ ക്ലാസുകൾ ആക്കി തിരിക്കുകയും ഓരോരുത്തർക്കും ഇരിക്കാൻ പ്രത്യേകം ഇരിപ്പിടവും നമ്പറും സജ്ജീകരിക്കുകയും ചെയ്യും പരീക്ഷയ്ക്ക്. പരീക്ഷ കഴിയാതെ സീറ്റിൽ നിന്ന് എഴുന്നേൽക്കാൻ പറ്റില്ല. അത്ര കർശനമായ പരീക്ഷ വേറെ എവിടെയും കണ്ടിട്ടില്ല.'
      },
      {
        type: 'heading',
        text: 'കൈപ്പറ്റ ഉസ്താദ്'
      },
      {
        type: 'paragraph',
        text: 'ഞാൻ ഉറുദു പഠിച്ചത് കൈപ്പറ്റ ഉസ്താദിന്റെ അരികിൽ നിന്നാണ്. ഉസ്താദ് ഇംഗ്ലീഷും ഉർദുവും ഒക്കെ പഠിച്ച ആളാണ്. മൂപ്പർ ഒരു മഹാൻ തന്നെയായിരുന്നു. ഇ.കെ അദ്ദേഹത്തെക്കുറിച്ച് പറഞ്ഞത്: "ഇൽമിനെ നാല് ഓഹരി ആക്കിയാൽ അതിൽ മൂന്ന് ഓഹരിയും മൂപ്പരുടെ കയ്യിലാണ്, ഒരു ഓഹരി കൊണ്ടാണ് ഞങ്ങളെല്ലാവരും വീതിച്ചെടുത്തത്" എന്നാണ്. കൈപ്പറ്റ ജുമുഅയുടെ തർക്കം ഉണ്ടായപ്പോൾ പരിഹാരത്തിനു വേണ്ടി രണ്ടാമതൊരു ജുമുഅ കൂടി വേണമെന്ന് പറഞ്ഞവർ ഇ.കെ യെ കൊണ്ടുവന്നു. "ഞാൻ അങ്ങോട്ട് വരുന്നുണ്ട് ഒന്ന് കാണണം" എന്ന് കൈപ്പറ്റ ഉസ്താദിനോട് ഇ.കെ പറഞ്ഞു. കൈപ്പറ്റയിലെ ഉസ്താദിന്റെ വീടിന്റെ രണ്ടാം നിലയിൽ വച്ച് ഇരുവരും ഈ വിഷയം സംസാരിച്ചു. കൈപ്പറ്റ ഉസ്താദ് കൈപ്പറ്റയുടെ മാപ്പ് വരച്ചു കാണിച്ചു കൊടുത്തു, എന്നിട്ട് പറഞ്ഞു: "ഇവിടെ മറ്റൊരു ജുമഅ നടത്താനുള്ള ഒരു കാരണവും കാണാൻ കഴിയില്ല" എന്ന്. "എന്നാലും ഒരു കൂട്ടർ അത് ആവശ്യപ്പെടുന്നുണ്ടല്ലോ" എന്ന് ശംസുൽ ഉലമ പറഞ്ഞു. "അങ്ങനെയെങ്കിൽ അത് എനിക്കൊന്നു കാണണം" എന്ന് ഉസ്താദ് പറഞ്ഞു.'
      },
      {
        type: 'paragraph',
        text: 'ഇ.കെ എന്നിട്ട് ഈ ആവശ്യം ഉന്നയിച്ചവരോട് പറഞ്ഞു: "നിങ്ങൾക്കിവിടെ ജുമഅ നടത്താൻ കഴിയില്ലടാ" എന്ന്. അവസാനം പാണക്കാട് തങ്ങൾ ആ പള്ളി നന്നാക്കി ഉദ്ഘാടനത്തിന് വന്ന സമയത്ത് "ഇത് ജുമുഅക്ക് വലിപ്പമുള്ള പള്ളി ആണല്ലോ" എന്ന് പറഞ്ഞു. അങ്ങനെയാണ് അവിടെ ജുമഅ തുടങ്ങിയത്. കുഴിപ്പുറത്ത് പാപ്പ ചെയ്തതുപോലെ ഒന്ന് ഇടവിട്ട് ജുമഅ ആക്കാം എന്ന് പറഞ്ഞു. "ആദ്യം അവിടെ ആയിക്കോട്ടെ ഞാൻ അങ്ങോട്ട് വരാം" എന്ന് കൈപ്പറ്റ ഉസ്താദ് പറഞ്ഞു. ആളുകൾ പരസ്പര കയ്യാങ്കളിയിൽ എത്തുന്ന അവസ്ഥയിലേക്ക് എത്തിയിരുന്നെങ്കിലും കൈപ്പറ്റ ഉസ്താദിന്റെ കറാമത്ത് ആവണം അത്തരം സംഭവങ്ങൾ ഒന്നും ഉണ്ടായില്ല. എന്നോട് കൈപ്പറ്റ ഉസ്താദ് ശറഹുകളും ഹാശിയകളും എഴുതാൻ പറഞ്ഞിരുന്നു. അത് ഇൽമ് നിലനിൽക്കാൻ നന്നെന്നും പറഞ്ഞിരുന്നു. അവർ എന്നെ അതിന് നല്ലോണം പ്രേരിപ്പിച്ചിരുന്നു, കാരണം തസ്നീഫിന്റെ ശാഖ എന്നിൽ ഉണ്ടെന്ന് മൂപ്പർ മനസ്സിലാക്കിയിരുന്നു. മഹല്ലി ഓതാൻ ചെല്ലുന്ന സമയത്ത് എന്റെ കയ്യിൽ കുറാസ് (ബൈൻഡ് ചെയ്യാത്ത കടലാസ് കെട്ട്) ഉണ്ടാകും. അതിൽ ഞാനിങ്ങനെ എഴുതും. അത് പിന്നെ എന്റെ സഹപാഠിയായ മുതുവല്ലൂർ അദ്ദേഹത്തിന്റെ ഒരു ഗ്രന്ഥത്തിൽ ചേർത്ത് ഇങ്ങനെ പറഞ്ഞു: \'كتب بعض اصحابനാ\'. ഞങ്ങൾ അദ്ദേഹത്തെ ചെറി എന്ന് വിളിക്കും, എന്നെപ്പോലെ നീളം ഇല്ലാത്ത ആളാണ് മൂപ്പരും. ചാലിയം, ഇരുമ്പുചോല, ദയൂബന്ദ് എവിടെയെല്ലാം അദ്ദേഹം എന്നോടൊപ്പം ഉണ്ടായിരുന്നു. മൂപ്പരെ ഞാൻ കൊണ്ടോട്ടി ബുഖാരിയിൽ ആക്കിക്കൊടുത്തു, കുട്ടികൾക്ക് വലിയ ഇഷ്ടമായിരുന്നു അദ്ദേഹത്തെ. അവസാനം അദ്ദേഹം നിന്നത് ആനക്കരയിൽ ആയിരുന്നു. സമസ്ത വിഭജന പ്രശ്നം ഉണ്ടായപ്പോൾ ഞാൻ അദ്ദേഹത്തോട് പറഞ്ഞു: \'നിങ്ങൾ ബുഖാരിയിലേക്ക് വരൂ, അത് നമ്മുടെ സ്ഥാപനമാണെന്ന്\'.'
      }
    ]
  },
  // Add your other articles here...
];

const ArticleImageBlock = ({ src, alt }) => {
  const [error, setError] = useState(false);
  if (error) return null;
  return (
    <div className="my-8 rounded-2xl overflow-hidden shadow-md border border-gray-100 bg-neutral-50 p-2">
      <img
        src={formatFileUrl(src)}
        alt={alt}
        className="w-full h-auto max-h-[500px] object-contain rounded-xl mx-auto"
        onError={() => setError(true)}
      />
    </div>
  );
};

export default function ArticlePage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [searchQuery, setSearchQuery] = useState("");
  const containerRef = useRef(null);
  const contentRef = useRef(null);

  const [dbArticles, setDbArticles] = useState(staticArticles);
  const [categories, setCategories] = useState(["All"]);
  const [loading, setLoading] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [notification, setNotification] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [activeMenuId, setActiveMenuId] = useState(null);
  const [starredArticles, setStarredArticles] = useState(() => {
    try {
      const saved = localStorage.getItem("starred_articles");
      return saved ? JSON.parse(saved) : [];
    } catch (e) {
      return [];
    }
  });
  const [imageError, setImageError] = useState(false);
  const [failedImages, setFailedImages] = useState({});

  const [isArticleModalOpen, setArticleModalOpen] = useState(false);
  const [editArticleId, setEditArticleId] = useState(null);

  const [articleForm, setArticleForm] = useState({
    title: "",
    slug: "",
    arabicTitle: "",
    category: "Hadith Science",
    author: "",
    authorRole: "",
    date: "",
    readTime: "5 min read",
    image: "",
    excerpt: "",
    content: [{ type: "paragraph", text: "" }],
  });

  const articleId = searchParams.get("id");
  const selectedArticle = dbArticles.find(
    (a) => a.slug === articleId || a.id === articleId || a._id === articleId,
  );

  const fetchCategories = async () => {
    try {
      const res = await axios.get(`${API_URL}/library/categories?type=article`);
      const catTitles = res.data.map((item) => item.title);
      setCategories(["All", ...catTitles]);
    } catch (err) {
      const staticCats = [...new Set(staticArticles.map((a) => a.category))];
      setCategories(["All", ...staticCats]);
    }
  };

  const fetchArticles = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API_URL}/articles`);
      if (Array.isArray(res.data) && res.data.length > 0) {
        setDbArticles(res.data);
      }
    } catch (err) {
      setDbArticles(staticArticles);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchArticles();
    fetchCategories();
    const token = localStorage.getItem("admin_token");
    setIsAdmin(!!token);
  }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [selectedCategory, searchQuery]);

  useEffect(() => {
    const handleOutsideClick = () => {
      setActiveMenuId(null);
    };
    window.addEventListener("click", handleOutsideClick);
    return () => window.removeEventListener("click", handleOutsideClick);
  }, []);

  useEffect(() => {
    setImageError(false);
  }, [articleId]);

  useEffect(() => {
    if (selectedArticle) {
      document.title = `${selectedArticle.title} | DarulHadees`;
      
      let metaDesc = document.querySelector('meta[name="description"]');
      if (!metaDesc) {
        metaDesc = document.createElement('meta');
        metaDesc.name = "description";
        document.getElementsByTagName('head')[0].appendChild(metaDesc);
      }
      metaDesc.setAttribute("content", selectedArticle.excerpt || "Scholarly publication on DarulHadees");

      const updateMetaTag = (property, value) => {
        let meta = document.querySelector(`meta[property="${property}"]`);
        if (!meta) {
          meta = document.createElement('meta');
          meta.setAttribute("property", property);
          document.getElementsByTagName('head')[0].appendChild(meta);
        }
        meta.setAttribute("content", value);
      };

      updateMetaTag("og:title", selectedArticle.title);
      updateMetaTag("og:description", selectedArticle.excerpt || "");
      if (selectedArticle.image) {
        updateMetaTag("og:image", formatFileUrl(selectedArticle.image));
      }
      updateMetaTag("og:url", window.location.href);
      updateMetaTag("og:type", "article");
    } else {
      document.title = "Articles & Insights | DarulHadees";
      let metaDesc = document.querySelector('meta[name="description"]');
      if (metaDesc) {
        metaDesc.setAttribute("content", "Web site created using create-react-app");
      }
    }
  }, [selectedArticle]);

  const toggleStar = (id) => {
    setStarredArticles((prev) => {
      const updated = prev.includes(id)
        ? prev.filter((item) => item !== id)
        : [...prev, id];
      try {
        localStorage.setItem("starred_articles", JSON.stringify(updated));
      } catch (e) {
        console.error("Failed to save starred articles to localStorage", e);
      }
      return updated;
    });
  };

  const isStarred = (id) => starredArticles.includes(id);

  const showNotification = (msg, type = "success") => {
    setNotification({ msg, type });
    setTimeout(() => setNotification(null), 3000);
  };

  const handleArticleClick = (article) => {
    setSearchParams({ id: article.slug || article.id || article._id });
  };

  const handleBackClick = () => {
    setSearchParams({});
  };

  const handleShare = (article) => {
    const shareUrl = article
      ? `${window.location.origin}/article?id=${article.slug || article._id || article.id}`
      : window.location.href;
    const shareTitle = article ? article.title : (selectedArticle?.title || "DarulHadees");

    if (navigator.share) {
      navigator.share({
        title: shareTitle,
        url: shareUrl,
      })
      .catch((error) => console.log('Error sharing', error));
    } else {
      navigator.clipboard.writeText(shareUrl).then(() => {
        showNotification("Link copied to clipboard!");
      });
    }
  };

  // Filter
  const filteredArticles = dbArticles.filter((article) => {
    const matchesCategory =
      selectedCategory === "All" || article.category === selectedCategory;
    const matchesSearch =
      article.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
      (article.excerpt || "")
        .toLowerCase()
        .includes(searchQuery.toLowerCase()) ||
      article.author.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  const ITEMS_PER_PAGE = 6;
  const totalPages = Math.ceil(filteredArticles.length / ITEMS_PER_PAGE);
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const paginatedArticles = filteredArticles.slice(
    startIndex,
    startIndex + ITEMS_PER_PAGE,
  );

  return (
    <div
      ref={containerRef}
      className="font-libre bg-gray-50 min-h-screen flex flex-col pt-[60px] relative"
    >
      {notification && (
        <div
          className={`fixed top-20 left-1/2 -translate-x-1/2 z-[200] px-6 py-3 rounded-2xl shadow-2xl ${notification.type === "success" ? "bg-neutral-900 text-black" : "bg-red-600 text-black"}`}
        >
          {notification.msg}
        </div>
      )}

      {!selectedArticle && (
        <div
          className="relative w-full h-[120px] md:h-[200px] bg-cover bg-center"
          style={{ backgroundImage: "url('/assets/articlebg.avif')" }}
        >
          <div className="absolute inset-0 bg-[#1f0e56]/75"></div>
          <div className="absolute inset-0 flex flex-col justify-center items-center text-center px-4 z-10">
            <h1 className="text-white text-2xl md:text-5xl font-bold font-AndoraModernSerif">
              Articles & Insights
            </h1>
            <h2
              className="font-cairo text-pumpkinToast-400 text-lg md:text-2xl font-bold"
              style={{ direction: "rtl" }}
            >
              المقالات والبحوث العلمية
            </h2>
          </div>
        </div>
      )}

      <div
        ref={contentRef}
        className="flex-grow max-w-7xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-6 relative"
      >
        {!selectedArticle ? (
          <div className="space-y-10 relative z-10">
            <div className="flex flex-col md:flex-row md:justify-between gap-3 pb-3 border-b border-gray-200/60">
              <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
                <div className="relative w-full md:w-80">
                  <input
                    type="text"
                    placeholder="Search articles..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    className="w-full pl-11 pr-4 py-2.5 bg-white border border-gray-200 rounded-full text-sm text-gray-800 focus:border-pumpkinToast-400 focus:ring focus:ring-pumpkinToast-200/50 shadow-sm transition-all duration-300"
                  />
                  <IconSearch className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 w-5 h-5" />
                </div>
              </div>

              <div className="flex flex-wrap gap-2 overflow-x-auto scrollbar-hide py-1">
                {categories.map((category) => (
                  <button
                    key={category}
                    onClick={() => setSelectedCategory(category)}
                    className={`px-4 py-1.5 rounded-full text-sm font-medium whitespace-nowrap transition-all ${
                      selectedCategory === category
                        ? "bg-pumpkinToast-600 text-white"
                        : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                    }`}
                  >
                    {category}
                  </button>
                ))}
              </div>
            </div>

            {/* Article Cards */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {paginatedArticles.map((article) => {
                const articleIdKey = article.id || article.slug || article._id;
                const hasImage = article.image && !failedImages[articleIdKey];

                return (
                  <article
                    key={articleIdKey}
                    onClick={() => handleArticleClick(article)}
                    className="group bg-white rounded-2xl border border-gray-100 overflow-hidden shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300 cursor-pointer flex flex-col h-full relative"
                  >
                    {hasImage ? (
                      <div className="relative h-52 w-full overflow-hidden bg-gray-100">
                        <img
                          src={formatFileUrl(article.image)}
                          alt={article.title}
                          className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500"
                          onError={() => {
                            setFailedImages((prev) => ({ ...prev, [articleIdKey]: true }));
                          }}
                        />
                        <div className="absolute top-4 left-4 flex items-center gap-2">
                          <span className="px-3 py-1 bg-white/90 backdrop-blur-sm text-pumpkinToast-700 font-bold text-[10px] uppercase tracking-wide rounded-md shadow-sm">
                            {article.category}
                          </span>
                          {isStarred(articleIdKey) && (
                            <span className="p-1 bg-white/90 backdrop-blur-sm text-amber-500 rounded-md shadow-sm flex items-center justify-center">
                              <IconStar className="w-3.5 h-3.5 fill-amber-500" />
                            </span>
                          )}
                        </div>

                        {/* 3-dots menu button & dropdown */}
                        <div className="absolute top-4 right-4 z-20">
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              setActiveMenuId(activeMenuId === articleIdKey ? null : articleIdKey);
                            }}
                            className="p-1.5 rounded-full bg-white/95 backdrop-blur-sm text-gray-700 hover:bg-white hover:text-pumpkinToast-600 shadow-sm transition-all duration-200 border border-gray-100/50 flex items-center justify-center"
                          >
                            <IconDotsVertical className="w-4 h-4" />
                          </button>

                          {activeMenuId === articleIdKey && (
                            <div className="absolute right-0 mt-2 w-32 bg-white rounded-xl shadow-lg border border-gray-100 py-1 z-30 animate-in fade-in slide-in-from-top-2 duration-150">
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleArticleClick(article);
                                  setActiveMenuId(null);
                                }}
                                className="w-full text-left px-3.5 py-2 text-xs font-semibold text-gray-700 hover:bg-gray-50 flex items-center gap-2"
                              >
                                <IconBook className="w-4 h-4 text-gray-400" />
                                Open
                              </button>
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleShare(article);
                                  setActiveMenuId(null);
                                }}
                                className="w-full text-left px-3.5 py-2 text-xs font-semibold text-gray-700 hover:bg-gray-50 flex items-center gap-2"
                              >
                                <IconShare className="w-4 h-4 text-gray-400" />
                                Share
                              </button>
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  toggleStar(articleIdKey);
                                  setActiveMenuId(null);
                                }}
                                className="w-full text-left px-3.5 py-2 text-xs font-semibold text-gray-700 hover:bg-gray-50 flex items-center gap-2"
                              >
                                {isStarred(articleIdKey) ? (
                                  <>
                                    <IconStar className="w-4 h-4 text-amber-500 fill-amber-500" />
                                    Starred
                                  </>
                                ) : (
                                  <>
                                    <IconStar className="w-4 h-4 text-gray-400" />
                                    Star
                                  </>
                                )}
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    ) : (
                      /* Category and actions header when no image is present */
                      <div className="px-6 pt-6 pb-2 flex items-center justify-between">
                        <span className="px-3 py-1 bg-pumpkinToast-50 text-pumpkinToast-700 font-bold text-[10px] uppercase tracking-wide rounded-md">
                          {article.category}
                        </span>
                        <div className="flex items-center gap-2 relative">
                          {isStarred(articleIdKey) && (
                            <span className="text-amber-500">
                              <IconStar className="w-3.5 h-3.5 fill-amber-500" />
                            </span>
                          )}
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              setActiveMenuId(activeMenuId === articleIdKey ? null : articleIdKey);
                            }}
                            className="p-1.5 rounded-full text-gray-400 hover:text-pumpkinToast-600 hover:bg-gray-50 transition-all duration-200 flex items-center justify-center"
                          >
                            <IconDotsVertical className="w-4 h-4" />
                          </button>

                          {activeMenuId === articleIdKey && (
                            <div className="absolute right-0 mt-2 w-32 bg-white rounded-xl shadow-lg border border-gray-100 py-1 z-30 animate-in fade-in slide-in-from-top-2 duration-150">
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleArticleClick(article);
                                  setActiveMenuId(null);
                                }}
                                className="w-full text-left px-3.5 py-2 text-xs font-semibold text-gray-700 hover:bg-gray-50 flex items-center gap-2"
                              >
                                <IconBook className="w-4 h-4 text-gray-400" />
                                Open
                              </button>
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleShare(article);
                                  setActiveMenuId(null);
                                }}
                                className="w-full text-left px-3.5 py-2 text-xs font-semibold text-gray-700 hover:bg-gray-50 flex items-center gap-2"
                              >
                                <IconShare className="w-4 h-4 text-gray-400" />
                                Share
                              </button>
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  toggleStar(articleIdKey);
                                  setActiveMenuId(null);
                                }}
                                className="w-full text-left px-3.5 py-2 text-xs font-semibold text-gray-700 hover:bg-gray-50 flex items-center gap-2"
                              >
                                {isStarred(articleIdKey) ? (
                                  <>
                                    <IconStar className="w-4 h-4 text-amber-500 fill-amber-500" />
                                    Starred
                                  </>
                                ) : (
                                  <>
                                    <IconStar className="w-4 h-4 text-gray-400" />
                                    Star
                                  </>
                                )}
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    )}

                    <div className={`px-6 pb-6 flex flex-col flex-grow ${hasImage ? "pt-6" : "pt-2"}`}>
                      <div className="flex items-center gap-4 text-xs text-gray-400 mb-3">
                        <span>{article.date}</span>
                        <span>{article.readTime}</span>
                      </div>
                      <h3 className="font-AndoraModernSerif text-lg font-bold text-gray-900 group-hover:text-pumpkinToast-600 mb-3 leading-snug line-clamp-2">
                        {article.title}
                      </h3>
                      <p className="text-gray-500 text-sm leading-relaxed mb-6 line-clamp-3">
                        {article.excerpt}
                      </p>
                      <div className="mt-auto pt-4 border-t border-gray-50 flex items-center justify-between">
                        <span className="text-xs font-semibold text-gray-700">
                          {article.author}
                        </span>
                        <span className="text-pumpkinToast-500 group-hover:text-pumpkinToast-600 font-bold text-sm flex items-center gap-1">
                          Read <IconArrowRight className="w-4 h-4" />
                        </span>
                      </div>
                    </div>
                  </article>
                );
              })}
            </div>
          </div>
        ) : (
          /* ==================== ARTICLE DETAIL VIEW ==================== */
          <div className="max-w-6xl mx-auto">
            <button
              onClick={handleBackClick}
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-white border border-gray-200 rounded-full text-gray-700 hover:text-pumpkinToast-600 mb-8"
            >
              <IconArrowLeft size={18} /> Back to Articles
            </button>

            <div className="bg-white rounded-3xl shadow-sm overflow-hidden">
              <div className="px-8 pt-8 pb-6 border-b">
                <span className="px-4 py-1 bg-pumpkinToast-50 text-pumpkinToast-700 font-bold text-sm rounded-full">
                  {selectedArticle.category}
                </span>
                <h1 className="font-AndoraModernSerif text-4xl md:text-5xl font-bold mt-4 leading-tight">
                  {selectedArticle.title}
                </h1>
                {selectedArticle.arabicTitle && (
                  <h2
                    className="font-cairo text-2xl text-pumpkinToast-600 mt-3"
                    style={{ direction: "rtl" }}
                  >
                    {selectedArticle.arabicTitle}
                  </h2>
                )}
              </div>

              {selectedArticle.image && !imageError && (
                <div className="relative w-full h-[200px] sm:h-[300px] md:h-[420px] overflow-hidden bg-neutral-100">
                  <img
                    src={formatFileUrl(selectedArticle.image)}
                    alt={selectedArticle.title}
                    className="w-full h-full object-cover"
                    onError={() => setImageError(true)}
                  />
                </div>
              )}

              {/* Author & Publication Metadata Section */}
              <div className="px-8 py-5 bg-neutral-50/50 border-b flex flex-wrap items-center justify-between gap-4">
                <div className="flex items-center gap-3">
                  {selectedArticle.authorImage ? (
                    <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 border border-pumpkinToast-100 shadow-sm">
                      <img
                        src={formatFileUrl(selectedArticle.authorImage)}
                        alt={selectedArticle.author || "Author"}
                        className="w-full h-full object-cover"
                        onError={(e) => {
                          e.target.style.display = "none";
                          e.target.parentElement.classList.add("bg-pumpkinToast-100", "text-pumpkinToast-700", "flex", "items-center", "justify-center", "font-bold", "text-sm");
                          e.target.parentElement.textContent = selectedArticle.author ? selectedArticle.author.charAt(0) : "";
                        }}
                      />
                    </div>
                  ) : (
                    <div className="w-10 h-10 rounded-full bg-pumpkinToast-100 text-pumpkinToast-700 flex items-center justify-center font-bold text-sm flex-shrink-0">
                      {selectedArticle.author ? selectedArticle.author.charAt(0) : <IconUser size={18} />}
                    </div>
                  )}
                  <div>
                    <div className="text-sm font-semibold text-gray-900">{selectedArticle.author || "Anonymous"}</div>
                    {selectedArticle.authorRole && (
                      <div className="text-xs text-gray-500">{selectedArticle.authorRole}</div>
                    )}
                  </div>
                </div>
                <div className="flex items-center gap-4 text-xs text-gray-500">
                  <span className="flex items-center gap-1.5">
                    <IconCalendar size={14} /> {selectedArticle.date}
                  </span>
                  <span className="flex items-center gap-1.5">
                    <IconClock size={14} /> {selectedArticle.readTime}
                  </span>
                  <button
                    onClick={() => handleShare()}
                    className="flex items-center gap-1.5 px-3 py-1 bg-white border border-gray-200 hover:border-pumpkinToast-300 hover:text-pumpkinToast-600 rounded-full shadow-sm transition-all duration-200 ml-2 font-medium"
                  >
                    <IconShare size={12} /> Share
                  </button>
                </div>
              </div>

              <div className="p-8 md:p-12 text-gray-700 leading-relaxed text-[17px]">
                {selectedArticle.content &&
                selectedArticle.content.length > 0 ? (
                  selectedArticle.content.map((block, idx) => {
                    if (block.type === "paragraph")
                      return (
                        <p key={idx} className="mb-6">
                          {block.text}
                        </p>
                      );
                    if (block.type === "heading")
                      return (
                        <h3
                          key={idx}
                          className="font-bold text-2xl mt-10 mb-4 text-[#1f0e56]"
                        >
                          {block.text}
                        </h3>
                      );
                    if (block.type === "quote")
                      return (
                        <blockquote
                          key={idx}
                          className="border-l-4 border-pumpkinToast-500 pl-6 italic my-8 text-lg"
                        >
                          "{block.text}"
                        </blockquote>
                      );
                    if (block.type === "question")
                      return (
                        <h4
                          key={idx}
                          className="font-bold text-xl mt-8 mb-4 text-[#1f0e56] flex items-start gap-2.5 leading-snug"
                        >
                          <span className="bg-pumpkinToast-100 text-pumpkinToast-700 text-[11px] px-2.5 py-1 rounded-md border border-pumpkinToast-200 uppercase tracking-widest font-extrabold shadow-sm flex-shrink-0 mt-0.5">
                            Q
                          </span>
                          <span>{block.text}</span>
                        </h4>
                      );
                    if (block.type === "image")
                      return (
                        <ArticleImageBlock key={idx} src={block.text} alt="Article illustration" />
                      );
                    return null;
                  })
                ) : (
                  <p className="text-gray-500">No content available.</p>
                )}
              </div>
            </div>
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
}
